import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSparkles } from '@rtkwlf/pro-solid-svg-icons/faSparkles';

import { Chip } from '@packages/fenrir/components';
import { Tooltip } from '@packages/fenrir/components/tooltip';

import { BLUEPRINT_NEW_DAYS } from '../constants/blueprint-new-days';
import { useSecurityJourneyTranslations } from '../locales/use-security-journey-translations';
import { isNew } from '../utils/is-new';

type NewBadgeProps = {
  createdAt: Date;
};

export const NewBadge: React.FunctionComponent<NewBadgeProps> = ({
  createdAt,
}) => {
  /**
   * get an instance of the translations
   */
  const { t } = useSecurityJourneyTranslations();

  /**
   * checks if the blueprint is newer than 7 days
   */
  const isBlueprintNew = React.useMemo(() => {
    return isNew(createdAt, BLUEPRINT_NEW_DAYS);
  }, [createdAt]);

  if (!isBlueprintNew) {
    return null;
  }

  return (
    <Tooltip enterDelay={600} title={t('common.newBadge.tooltip')}>
      <Chip
        data-testid="new-badge"
        sx={{
          color: 'rgb(var(--aw-mono-black))',
          backgroundColor: 'rgb(var(--aw-accent-blue-secondary))',
          cursor: 'default',
          height: '28px',
          padding: 0,
          paddingRight: 0.5,
          gap: 0,
        }}
        label={t('common.newBadge.label')}
        color="info"
        size="medium"
        icon={<FontAwesomeIcon icon={faSparkles} />}
        className="new-badge"
      />
    </Tooltip>
  );
};
